

(function(){

  'use strict';


  const el = document.querySelector('.tw-builder');

  if(!el || el.dataset.initialised === 'yes') return;


  let config;

  try {

    config = JSON.parse(el.querySelector('[data-tw-config]').textContent);

  } catch(e) {

    console.error('Touchwood: invalid product configuration', e);

    return;

  }


  const $ = s => el.querySelector(s);

  const $$ = s => Array.from(el.querySelectorAll(s));

  const A = config.addons;


  const state = {

    engraving:'none',

    font:'Quicksand Light',

    warranty:false,

    boxEnabled:false,

    boxChoice:'plain',

    quantity:1,

    busy:false

  };


  // Touchwood v15: controls are optional, separate Main/Side A/Side B.
  // Purchasable accessories & cart logic below are inherited from the v13 builder.
  const c15=config.customiser||{};
  const designRoot=$('[data-tw15-custom]');
  // New and unconfigured products default to Standard (inside engraving only).
  // Advanced customisation is explicitly opt-in via the product's version field.
  // Accepted Shopify Choice-list values: standard, face, face-material, full.
  const requestedVersion=String(c15.version||'standard').trim().toLowerCase().replace(/[\s_]+/g,'-');
  const builderVersion=['standard','face','face-material','full'].includes(requestedVersion)
    ?requestedVersion:'standard';
  const designEnabled=builderVersion==='legacy'?!!c15.enabled:builderVersion!=='standard';
  // Face + Material allows customers to combine artwork, material and text on the same face.
  const multiFace=builderVersion==='face-material';
  // Full Custom supports 1 or 2 sides with the existing Ring Sides metafield;
  // when it is unset (0), default to two side areas for the full preset.
  const legacySides=Math.max(0,Math.min(2,Number(c15.sides)||0));
  const sideCount=builderVersion==='full'?(legacySides||2)
    :builderVersion==='legacy'?legacySides:0;
  const allowMain=builderVersion==='legacy'?!!c15.main:builderVersion!=='standard';
  const allowMainInlays=builderVersion==='face-material'?true
    :builderVersion==='face'||builderVersion==='standard'?false
    :allowMain && c15.mainInlays===true;
  const allowedSides=(Array.isArray(c15.sideTypes)?c15.sideTypes:[]).map(v=>String(v).trim().toLowerCase());
  const canUse=type=>!allowedSides.length||allowedSides.includes(type);
  const targetKeys=[...(allowMain?['main']:[]),...(sideCount>0?['a']:[]),...(sideCount>1?['b']:[])];
  // Product metafield custom.design_first_option chooses the first visible
  // design category on every allowed area. Unsupported categories are skipped.
  // Blank or unrecognised values default to Image.
  const configuredFirst=String(c15.firstOption||'image').trim().toLowerCase();
  const firstOption=['image','material','text'].includes(configuredFirst)
    ?configuredFirst[0].toUpperCase()+configuredFirst.slice(1):'Image';
  const permittedOptions=k=>{
    const base=k==='main'
      ?(allowMainInlays?['Image','Material','Text']:['Image','Text'])
      :['Image','Material','Text'].filter(v=>v==='Image'
        ?(canUse('image')||canUse('crest')||canUse('fingerprint'))
        :v==='Text'?canUse('message'):canUse('inlay'));
    return base.includes(firstOption)
      ?[firstOption,...base.filter(x=>x!==firstOption)]:base;
  };
  const initialCategory=k=>permittedOptions(k)[0]||'';
  const design={route:'later',active:allowMain?'main':(sideCount?'a':null),category:{main:initialCategory('main'),a:initialCategory('a'),b:initialCategory('b')},picks:{main:null,a:null,b:null},notes:{main:'',a:'',b:''},expanded:{main:false,a:false,b:false},artType:{main:'Crest',a:'Crest',b:'Crest'},artIntent:{main:false,a:false,b:false},faceParts:{Image:false,Material:'',Text:''}};
  let insideOpen=true;
  let inlayImages=(config.inlayImages||[]).filter(x=>x&&x.name&&x.image);
  const uploadMount={node:null,done:false,pending:false,pendingArea:null,completedArea:null};
  let shoppadHandlerBound=false;
  const esc=x=>String(x??'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  // Transparent, reduced-size versions of the six EXACT Shopify icons supplied by Touchwood.
  // Embedding them avoids theme asset uploads and prevents black square backgrounds.
  const iconAssets={"image":"data:image/png;base64,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","fingerprint":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABoCAYAAAAdHLWhAAAZ1ElEQVR42u2deZicVZXGf7V0J52FJBDWQBBCWCQsAwFZFWWLgOwq28i+OIyIOsiIA6My4qg4BmcAB2VQkD0BEVACiAGEYZkAKltIGEjYs0FCutNLVX3+cd/z1Onb31fppKsrDfb3PP30VvUt973nnPe859xbuS22nMTgMXCP/OAQDAI0eAwCNAjQ4DEI0OCRdhQ/oPedAxL3c60jGQSo/8HIsv5KLwHIR6AmHxQAiwMYFPsqr8QyRgJrA50RAHlgGdAqILOuk9frk0GAeh8TK5ELKwDjgL2AjYC/A5qAzYExeo4mN9B5oEUALQbmA7OBecBfgGeBJREwPh5XBgFKtxgbmLU08NsAnxYg28pS0o4yUIqsoAkYBWwC7Bi9/jXgJeAh4H5gLrAgxa2ucavKDQCpp+Dc2FbAxsAxwAHA+BQgKpFldTmAmvW3inOP9nd/vUJkLS8B1wPTdb657rWVNQnUmgQo7wZ7FHAE8A1gghvALr2mkGHtZbmwJQKkExjqwBkOjNXf4qND35udxSwVOD8BbgfeT7nXDz1A3p2NAD4LnAXsqtle1PdcNNPfl2uaA9wLPKMBXaTBHiGAjK11ys1tIHe5GbCf3N1mAs+Oku7HW9ofgF/KBb4RWfqHFiD/kLsBPwD2jqxliHv9Ig3ULcCTihPtfXQ5LcB6AmuK7mPjCKyCs6r7gG8Bj64Ja2oUQN5qJgD/AhyvGd6l/5kLawUeB67W4CxcSV6T9PLaZMSTscDpinl7R+61oGu1A5cBP5RLbVhsagRAfsbtpwf9aMogdMpSrgIezhjgpI/sKpeiRHg6P0UT5zC5zEQWb5PnL8AFwF0p5+kfl7P2Ous1ApzhwEXAFYoJXfqfuZI7ga8Alypnybm8JMmwlJx7nX33X7kIkCz5x19rDnCb4s5awCT3DGVgQ+Bz+tuTboIlH0QLsngzDrgS+AywQm6tqIf7o/73R+CtXmT1+UhhWJWBKUZgJzWUBYuTn1Gc3NrlWUU3qU5RnOy3uNRfFmTgbANMAz4hF1YQQMuBt4F/B25V3Ml6yHyKNRn13lzKwgS5zXWATcXSRmvGjxQDLEXAFDJcVOImwmzgAZ1jO917RV/bAJ+SKvFaf1lSf1iQDfT2yiU2Fx0eKob2J+BU+fiFGoQkAicO7HbsrWR2E2AHKQyjdS4v1XQBbTrvYrmuFzSY84BHFPjTVIw0YjNabO8qXbvkrHIBcKiITd2peL0BMnD2BX4EbOFm1Qjg18CZkaxSS/IB2EMzdV/lSsMyhNOKA7RV5xmVkaA+Kbc6E5gR3X+SEqPs9wnAVOAQZ0lF4B3g88CD9XZ39QTIZs+eclsbSqwsKvf4D+ASZf2FaGBjYJqAg4ATxfxGRtZhbqi3WmJJ95ZzrKxJVjYLuFG0vjNDi/P31wJ8H/iSo9oF4D2pITPraUn1AijvcpwZigMdLn58VQwul8GiEpdEHgx80wmciUAhyvQR6ViuifCWrLRNAz1eAzVKLspb0Pt6rZeAHhMhuDsCKslIGc5XDPWMdD6wv7S9ulhSPQCyQV8HuEHuqNURgrOAazJu2AagRUH+RyIUHpgmd402KdDPKqbMV4x5LYVNNVEtSewGfATYSar4+Mgi886qH9HgP+asLslgel+XNXW5az4sBb6tHop4vQDKya0dqRmdyC39I3C509fSrK5JwJyln3GanB33Kz+ZBTyxCqpF2jFBgB2phNQrB0ahV0gwNeUgn0FiKsDFUkbKjoZfCfxDPayorzTbbvSfgHN0k01yHT8G/k03XE6JVxVpYNcCf6+/lTRQzWJZ1wIX6jyPSbTMRyJqLkUhSOhelfXvWSJF4BbN9jZpc8OdZQwhFAe3E81+P4NGF4DfE+pUu7tr7wq8IkE33xcr6osF2ezYSW6nxbGae4Cj5O8rGX58D7m+LR0jstrOPSIUT0duJamDX0871+aaBMfq97ID4BngNFlvbBF5R7cfBXZ2lvgm8HHg//siCfWl7creO0Wzr1M3Nk95TlsKZTXL+SzwW4HjM/R3lJ2fIHAKbuaWa+Qq+QzJJ5ch85RdslvQIH5R153nktiSyMpdIi9N7rw+R+uUi17oBOBxYqJpUlNDADJ6PA14WW5tBfA1zZ54thn1PA64Weyq5NzPr2RVtzoGWI7cY6y9eWWhEv1coXuPQi76wp0/p2T6esWnaQ7kkvTD24ADHbB+HArA/ynHa5WLfl2TsE9EoS8xyPz8YrmBVtHOO+jZt2bgnAr8j3sw08duAM4A3o1kndhKkkiFHgKsK1HzE5rtEyXDmOWVUggKKdZlvy/XJBmjuGIgWW72hCZkgZ5dRC8IqFFid4/2VfGuJ4urrESCP1TST86xtBWEYthUqlXUSkbegQDZTm51ZzGyTZTTGNjLZIFGNhYDf1ZucpsGscNNMFImhP38ZeB7iq9lgbJAlvRMBrtLHHh9bueqp5KQloTmxXAOVx1oqHuACnCymFqtzH0Eoah2oqT+rVNc83KxPqvItkoSGh29bqnizb0qbSxayb1XpA7c4u65IND3V5zMAmnAlxvsxo8Cfq6BxlnO6XrwMj370+yBPwJ8R9rXGDeIRiyaUgJ2PiVW+hzF/v+KLOq/CY0iScpgW/52onPNlkr8QS6vs0YCPmDLDWYBTUpUt3KW06VYdENUQvAsbzihgHe5qGqL09MKEbtbrAF+Tt+fVymjzemABcfMVsjCxirXOVzW9yw9C3BmMU8LiP0d+ZggQH9PPxbt+suCjBRcKlbXSrVQd6FynCLdi272no9I1t8/JScxN/WYyMjTAmMZ1aYTA3G4gvU6IhGHAfs4SzYh19Rxr7R7sdMmW5FQpDvAsc9EHuIO+qnrpz/rQYfJhXXpgUZJXfjnFPps7zkQ+E8xMV9zQfnJlcBNUhRKq3hfTVIuDlfw39Sdw5jm8/rf/Snurkny1T3ALk4nnC/FfQ79UFmtt4sz/z5OcWekA2emktCODEBPkuVsHOVHCwTsSRq4pc715KNZnkuReHw+856s71f6/0epNodUgPUF4BuEwmIs07QBr8pqmjXJxuh9d/SHm6snQDk3E3+p2GFgLBIbWhQ9tMWcc52oihvUezVgtylOxFl8QnZjCCmvs/O2Elq6fkcoj2/pQLSSx1xpdp4yF5UDWRXVVIlJwIvR6wccQGYJnwPO02zLycefKwvyLsB89mmi4B7gHPDtjOQ1ca/z50tqxMNcyvvzkpZu0Gv2cKytSQC8CTzlBr2i980SKJMc+dlded67fZF2+gsgG9wNJOOMkI9eS27pvMhybGAPlytscj79feliU1Oob47uTYOJXM1YXbtZE2KMcq6So+S+ldhLQEixfkUJ8BBHpQ+Sq3sxsoycFINj9IzmxjdwMlFdrKjeFdWfySKW6gEXilI/6AKyvXZnaVUWp0Zq9h1JetnYA9UsFf2TmrnbSPJJ3HveUrY/Q9+fj3KlSkoB7hCRkBYH0kJd42X3Pvt+JqFSjLOko+SSB0xF1W7kU5o9Q3WjzSIFvppqljaasNRjL5evdGpGzkgp8BlYzbK6LyhOpKnUVs/xxwoF8VsJJe2OlGvY70cTehS8xT6ggV8WWcYIgb+5rpsX7d9LFklfLakeBTtU8LpJJv6+zP4e5Tyk6HQXq/ayTLN0OKECOU2/l1Ikn8OV9X9VNByXxdvSk4LAqDirMPlnEqHzZntZw+v0XFVXVMLaIcpf0s9bilg8Eg14WZb5OZfXjdJ4TK+Hq+srQEU92Ff18GVXMzlXwmTODVgi13aFG8CRwE+pVl/T8ptLCGXxzVwpwdYMmXW9p6D/rgAZTvfFWtakv7UIwFIF+7gHrwD8r6jzrtL5hui+b4+YaCKwW8Ra7W/bKW4921fCUI+K6h6yluHOD98ui3gnkuNzchcf14wcKhdxgAY4ZllriywcJ8souqy+XbHqKQXsWRq8oix5omLUx5RYDqHnOqCrREgqzrrt+zrKmWxSNCmJPieKRRBazB6QpZUdQ/wYoaFltV3d6lqQPcTaSiInudn3joTQue51PqieTXVFdqK4Myd66EQD/BtJPkbZjWHdLK3uuxqYF2URXXJJ1k16r2Lgk7KILejeIzGZ0Dp8b0RICppAy5W/2TNvL1b6ehRXlymBPdx5FVtn++u+5EarC5C5jtMIDXxtVFdZf51QIs7TvXljPVHqMZrJQyUFXZESp4bp7590brNZLvNkFcPmpagGnpV51zUXuI7QZvxxuVXTAScrbtwfqdB5AT9FykjFUfr73aQxrzFbgB7kJt+OilHPrW48yq+m9ZTFxE7QzLXm99sVyGMaa2rBFi4RXKG4Uk7Jcb6lmVt2LuN+Be7f0b3xPUlxjXEZ3BSEmwiV1xedalGWVR/rrpU49vdDd46E0PO2TkSSzPJ/pjKExcWcrHycs7aGAIRm4WayhNESDc/JqE6uK5rqVYTrnBUkjibvrfpLuxMpZ2oAX3MPHysKSVT78euPfB/1ixI3n3OuJydmOSmqiObkZue58zSLtTXRveSdCNAzJAXZ4uSR9OyI7VeA7OEXana0CpwTJY3EbiKRb57oSgELCb3aS9zrRyp2/Vgup4NqO+0Zjj2VI/CNSo8XiGe5GVuOFAMrtb+hfGexA3w8YZGZT3atu/XmaIKe4gDKRYnqXBGkhbrn85QTrZaL62uimheDWS5XF7s2xGymE1puTc65WG4sH9V7rlKMWa73N4vhxcqCXWesBnpfxZKxSh5tR5H7lHQujCaOnet0uWS/r8JFhEZ6PyF2pNqgaG7zBAdcXCpPnLKxkDXUF2e+940UcPyN7iZwbFXB24T2pkr0+vGElRGdrqr60xRwCq529IBqREfr/UP0v00l21ymmPD5yJLMkq+RslBwVPoMenaoviCmh7PsozMG3QBc0Fdw6gGQZ0xx40RFbus4ui8zuUUUuBAp0UfJ2gqiqOZC85GGViY0Pk5TQlgSqHmXJNtAtmtyXCdrqUSCaUkFxGVuEmyk9/gx6tBEMBDRxFu3RqkjRx16E/oKUEL6cnRfDj7ADUy7mFRcyymItVWcpVytnCoXsah9ZIEjnFU2y33OclLNEKdoNym27eeYmjGv5yTaWjvYEFlRPppYzxLat0ztGKeYl2SMY1120OqPHRfNeoYpWOIG5U7JKPkoe99NEkyHBrNVRT8ckMagpjq9rqD3TFXCu7tAOFZxrs0N6HDFm1Ephb6fRMrAZMk3PmYtIbSI+ZztRNJX8dW9RF3vcyYapF3cLG9TTEhzA/sogTXQHhaljpPdkwlrUw3wTinbX5HE3yWru13B/niqyyHbpTqfFEk6iSzvTwK+rHztYHo2ZU6T1mcTZCddv0z3duABC5DFiLGqiPoq5K+lBsdVUBMXcf79ty759YH3+CgxvEIxrehyHouLzbrmd6iWsxPFxFER2+xUzQon1h4SJcEFTZprI3DPlvaX1LOS2h8A5Z1Mc43LRQqadZekBM2KaPoWEf2d5f5vD72xEyOtfuRVC98AaUtZ8oSGwwVUm/snypKIJKL7IhKxrZswnkrfKNZqmt5WhAVclf6wonwd444leJdo9vkk8dsKxrHKgGKPSUB5VULTVoGvRfcdrV4RZc/aM8eAWqzXGqhjCE2HcWV1lktc0cBvFMXAAmG5/XfpvkLibMXbklPccwMBoHjVwXmEvjLfanu3q/+kXXsDpxzkpBS/ncKEJolhWZ/dCtL3gUuTpV6LACmlJJjLqe7Z0CFPcGBKjpMTKZlJ991LfiTSUKL3OxI3jGavK9b1A7q3KL2qEkMX6fsPmMqNo9cvabCKkV/vcHpap7L7LXvxHH6VeJKRm1hL8MM6lxX3tosG2t7fRbVj1soLQ6XWny9t0seuNQKQtfJ+Whn9F1wsKEpDO15KQ66GG5pIdQM+JM+nHV1iYiXN7lflDmsVwzy4/jylFG2xIhKDEzcnpZzfrOgpJb8rXOwsE9ZIzXR6XbnRANlDD1X+cLcepORm+NvKSx6tUawqKa7sQLXRPiEsD0kb9GHKTaxM8LLA7w1AXvws0rOpJHF1o/ccQLs4hTuXAuqNhAXQ71FdBN2qZ7papRFr/m+4BbVIdq9Q7ZIpSrPazyWk5RrX3VbBuFNx6C3lI9CzZWkLpxogZthbP98VDeywlHqOxb9HnVscTtjxKk0tMNIwXWrJU3r9cGdN+0o52WF1x7svAHUoKSxoRnYq5ziaagWxspKZPYVqhTWRq3wpQ5q3bSttS8w/s/LNIuz6I6LnLWfcUyuhD8GDfphibFrBzRLmJwml+cucrldwE7nh9SBby3k81SrqbsC/EtquaoGTd6Lk2c7lmIKQZRVjHNtql+AaP0MWvW3WBLIi4KgUYO25Zrg8xxos96qhuVnSvESKxv5S0Dt0ntvoub10r4/V3djccp5nCJ2gscxT6UUMO5VQOrb8Z67cRbze1RTknXRN08hmp+RVaT9Dtf+uKQI7BqhAWCR8txSHTk2e46RK1Cq72DWfkEy0sZ7rFcVaWI1O077S7HgbypVttGpsZ7Joqi/A3aJEMY3x7SnFoV0AvRvlSjl6Vjfj3Ue8arCyoH2XmxgVTcIpK9HcvGa4QhY+WyAvWlN5UCX66q1Od7lzMwVCn8ClKbHH7u9gvd4qso9TLZfbOU4iVD1vFJi+X+DNyHo3yohzZTdZZkSq+1TJV+Ua4xY3r+T7qio06gOerDi3AaGsvavLTXKEotm7GTlHM9UdsGzApjvmaOtFL1UcPIbQluWtZCHdt6WZqPNmCZxlQkl+hbvmloqx9EIYjbuKkoEMkImKm2hmHkF125gC8F+Ezpm0nUkSQlP+ZKrN8+8RimcezHVlYVYunxhZyJuOaldcTKBG0H9CeZ5nfqcrEW1q1Pjl+9lqLCE9RoF3b+ciCoQVB+fWoMo5SUVGr5ukOs+PAN3MDaztmOV1uvmaEEP1v01kzVmM0Rjb96RsFBx458tai/2lYPc3QH7GtYgMXCNdq8Nl8y8QtjGrpBADIxOHKv60U13C/zNZkX/PWDdQ7fqf/2yGV6U8dIn6jhaotQBK9NojxDALTsr6EmGd68Z0b2bJDXSAjBaPEY2+Q7PNZm7BKdz7yfWk7fibyGVd4OjxUKkMs0nfsM/O0yIJaLE7nynVw0SbC4TGE8ju+DQreomwMeESF/PKUlHuJTRrjqFnD96AAsgecAjVD6L4uaSOTqqNG0WRBGtybMu4p4oGZVfnErtEJt5MsbgJuo5Z1kt0r8h2ElZglB152JOVNxOaC5shUfhllzuWCCv7LpMCch6hQb9ST0vK1/k8XxfT2doB06yHmqOE70zNxnyNPGlPub8ud/5fSSVOs55xGmhb3Tcrui9Tn1c4UXYrJ9TWOsqONBxItY+u6JTxHVVqmUV1nVB+IAFks3BfqgWvZn0tIxSzDlWOkqU2WJ60oaxsNNXe6/lUewtitWCY4pt9mFOnU8R9fJuvWOS3vfwGvSuuGQF5WfnWd+VG/ccctGuiXBTlTwMqBv3UySOvEUrdB8gaXqR7s2JanrS+tKuPUl0d0CXN7tUUtpcjLFEZ76SaRS4x9YnjUiXIXpI6RNbeG1XcBnwxoQdhf3mL112MxOmJdVnp3R9bwexO6GGeTe8+C67gLOcauRFfMv8aodE+a9X3dYQ+afvErTsJrb5+kZjv5X5UMctqV9OlwGctv6wlWaHJcYDO8WdNylbqtONVvQFKo8tZ4qnXzXYlNBruTGgXtl3lr9fgp21UZDP0QeVXnXKpJwO/SBlwa8U6UZZedpLM6SI1qwKS32LGCFLHQKfZfl2OX2WdBUwLYQHyLZJzfD/DzYQVfPmMeFVRQJ7sJKFlhPWqZNDwdpGNh5xVV8TEjqDnx6OtzOX5z9rroPtWNQM2Ua1kABMry9sQtmG5VOJlhwAbor+fRLU4l2TM3uP0HqvzPKRYl88AyPbp+aLLa6xN+VpZl89neiN0Js4a6/6xaY0SSz04n1ACex+hWrlc+ZA1u/+AUAhsz/Dj5lb2ljuz7WCQylCi9sZKtu3Y2c5iSoSq69WERscJ9Nw1uLdMtr56WT9/RFo8479MWMaxg2LNcg3QSEI/wrmyqKylGxYzhhKWxG/lkuCZhI0zan0sAI7t/UUJ7RGyJFv3sxNhVUa7mGinAz1Hg49GAGQDfbBY2jCnIAzT4P5GZOCBGlTcK+MnE8rLXQ78r0jf6w29Nat4llCi/xjV5SwmMx0sS15f+c8S1sCRb5BrMznGiMMwuaU5hH66w6gu6irXoLYlQivUD+n+KcV3iF7n6X0fmr13qnKae6iWQGyXrA1FYp4RkWhptCU1woKMFMyRS9pG+cI0wucEzSB9lV5a3jGBsPJhPZfHLFDes3g1760gVWA6obC3C9WPXCs7hribLOlpRy76/Sg2aCLY7ryfp7qPTRs9938jI+aUNUC/INRyys61XUj3rcJW9bBztRMKdDPkLg/StTwBGPthjEF+sEuSYXyWXwsY+/8Ryl82pXv95ZuSb1bFtdWy8rykorslOb0pax0iEvItqh8a0phBa/BnecfsLFmJGrE+YResUxy9Nsv5OdV9f+q523tsiSMI7WHz1gRJKDb4er1poLCdpk4nrLkxN2MdPUjZvoTqKoR6zuhYhV6uL2jAR0OvaYB6w/Z2V6yZ6ICx5vqlEk+v7ufBSjKkqaTRg5IfQOBYbnKBwGl3VlN0ysPV1HHT1jpZ/YceIL/M8HH9bajAma1caQpBuS40iuIOhKM4AO/p+wrMkwlLN24mqNS5OrC1D9zRaBa3SilARKn/poAZaC4uLSZZo3rubxWcgeriYpD+po+BClDC4DGgXdzgMQjQIECDxyBAH/7jr5nSpB3caggGAAAAAElFTkSuQmCC","material":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABoCAYAAAAdHLWhAAAUq0lEQVR42u2deZxV5XnHv+feAQSGbUAWiVEioLSIBFwiVSqamLhRC4Jr0tpqNZpqpKmtJTFKm1hjXILELTFG3BK1MYCxNnEJVYNxyYYWAqmglgIBIYCsM/fe/PH+3s997jvn7neGO3jP5zMfmLnLOed9tt/ze57nPdHI0WNpHPV7JBpL0BBQ42gIqCGgxtEQUONoCKgLHk37yH1Ewe8Z/S3TENDeF0omRhCREZIVVJcTWGIfEUyT7qUn0D8QSNq8NxFjbQ0LqqFgEkBKv/cCDgNOAiYAfYEDgKHAK8BW4E3gp8AqYAewzShmpitYVFMXE0wKGAz8FXAO8GFgYIxVTA1+Xw/8Bvga8LwRctJYWV0eyZaBg+tZOEnjovoAnwYeBGYAw2RF6D0ps9CpwK01A4cAnwEOB94GNgKtJlY1BFRBbEwD/eTG7gUuU4xJm59IgvQ/CfOvdYnenY0B/hYYBfwe6A68J29Sdy4vqjM22wfxlP4/BZgDTDKWYa3LH3+QG9sqoLDbxKMoAAz2syngWeBi4B3zWqoRgwoDgMmylrONJWWCxd0EPAY8JVCwXe9r0r8HyC3+BXChXGIyQHZJ4GTgJWAe8Ei9CWpvW5DPU7xmHwNcAUwD9suj9RuBu4H5wO9KCPBNQntDgdnACYHQI+NSVwL3AbcD7weu9gMloCiICyOBLyj4t+hvbSa+oAW7W4v3dmB56QLnsa/1Ab4FTNQ5CfIk71Fe0/vu2duwvLMFFNIvzcA/yAUdlEcwrXI9/yqLIWAIMiVaqRfGYH3mOOCfZLX54tuzwEOyqjjF2qdQXMK4lGZglvz+DCGzlIHFPlY8qZznm4o5UYXanDHn3q6kdTnwfZ33IGBAzHcfApyiRHgPsCxG6F3egqwf76Nk8QxgeKC51sW8ANwMLMgTq2rhXhMmxh0IXAmcZSw5FSDL3cATwJeMJXe46+tIC4qCRPNjSjL/UrRMCAASCtLXarH+xyxORyyCtaotwI+BRbLuQ4EeBllmgG7AWFn8ICHH3R1tUR0hoFAwhwA3ArcCBwdB2QtmBfANxYQfBwE+04kueBOwUIvfrGS2KVCSvopf0+T2VstlhrlZ3bm4MJf5kOLMxbrZOGj7HnAXcL+shyKorLNh/2Tg74DzCwCJVcC/AQ8Du2p9D7WyIGsxnsx8APiEqBQLALzbelQ3/7A0N9nZCKmA6/PXuBr4AfBLsRp9Y+JOi5LhicA6YINcX5IaFA2rtSALAFoUX2YBf1JA4x4E/lOubGMg3LrjKk2snCLXdpmSXpsS2GR3oSzq1Rjl7TQBhe7sVOCLwLGBYOyFv6b3/Fcg4Lql+vNc50gp4j+bpDpEfDvlur8DvFGNoCoRkOWoTgL+XiaeTzBLga/KaraYm6hXqynFmhDguRy4SHmcvX/vLd4TIzEXWFuJUpYjIPvFR8iVnR9z4f7i1oqW+UaAclJ07SOMQYcCNwCnKd5aMrbJcHwPyL2vKkdIpYIE/4XNwL8DtymvsXmCh8zrxRBcADwjqmavk441BhEYwLNBjMRLwAhZlhViGtjfxLAM8HqQNFclII9EDlAmfTau5hIKZqd4qwuA/9DvsI+0PxVJdBHiexD4hRLaoYFiZsSenCFw8YLxPhULyC9uLwX3Y/XlVoMygqJ3yro2dCZXVSeHzZ9+iyN3N0ogQwKLygAfFyR/1bxWUQzyMeNKubVWk1mD65j5JvB4LSDlPiYocDWt2cr3BhtrSihGT1BIyJv/FeuL8yc6JzDndcBfKxF9nNxS9QdVOJiY4+muXThy9TixJRi0NwyYbhJjyhWQd28twGijHRHwnIjFdMNq8goqpbVqEoqbK2uxwGpMMbBQSmdp0kBnj+aOF1mYZt/p7+5It4eQXDLwRP2K0VuJIloQKdlaTm6b04HAOAlnN9nW28bRPrFtJduTNyjg+t6oFmZ799VTdE7K/O0Y4Ghgs5BLhg6g27toIuuBwmBcr8UdQsA2h1qHY/p3FbKgYgLyVrQU+HMlYq1kmdqRAhB/KrZgRaA9H1TBNIlpuR1XpW2mfanlapMLpauJQWjxZ+IIz24GsXmLmonrUXsI+EgMebivw+qECQEXAouBm0QDtQUcXSRkd1cp1FepVE+Emwz4vmLO4UBvg0jSuBLx4TimdzjwK1yDhhVUZh8TjB1z+YQs5guK0WFrcgT8TG7tvlL5uHIKdr5xYrEgdotcXHdyGzAG4Fp1z9Tnfi0typTKP3UBV2bv5TAJ5iuyGNu0739W4gjVS/X/ksnScssNYR3odFwB63iyZe2MyY/AtSrdQnZOJ0UXms/JwxL0UdC/jGylFePy/b2txhXwbgb+jwrGXSot2HnNaBOdcR2uLtTT3Ew6iHNbcbWTJwyf1xXcXqiUBwPXyFVFRjChG18vaP2TqrB6BT0JSeNfD8UV4y6SoBIB32StZD9RG0crPm2sc2gedicNwM0nPYJrJgmpHQLapjdwFG7AzKPgPWSn/GpuQfYieuCa3G3Z1womPFIBotshwHGjcijqjDKyMeJAHKl5Pa5QiXktTsHStGfzX8SVH2biGlC6S1g1syBrumcD38Z17vQMYKJ3e4/ihqQ2AR+VQDEC6KG/nyN/vlrvZS9bVMIIpzuu7fc25SxDie/p+18p6/dwfXTDyC3pp+UWu+n/78j9RbW0oCSu7n6jFh7a198RuvNN7pv1twnAZ+UGIbcu4j/7rpDQPLKFvs5sKAnjzJG4DtczAsUKR1VuBpbg5l9RevFJXFfPsDz3+h6uBHF3KTG4mICslH+IG85tM39P6vflwFUy5V0Bm+Az65OAzwn5QfzYx+u68AW48cTOKJVbRRgDfF6uqD/xg2ObJZh7RdfY17yAR4pJuDQIDSmyo5anAk8XU8RiAvIfvkSZb5tJupC5bhOiWRLkCZmYBWhSsJyn/IE8i/CK8oqFHRifrPa2yDNcLUIzzkPswE3zfTGImxY2W0vsq5j1OYEj/z1tWoffylK3GwGWFYOslXybbEXQJ6xzRGsslEtLET+BkDGIKKVc6HuykAOILwkfCJwrQjYp1GcXIFMj4fSTu5knq+mlBUybGLMHNwYzEzfVt5b2vQbh/SbkSd6R21+mexpuFHZ/vf5aIe6ymIAyIkj/RYHdL/bTygX+oODeWkLiaX34DlncfGnQaLkUK6hIQXeqNLG7fH2Gykob9jPNuqebcNMKA2g/nxThegZm671+bL+U2GiVsg1XVkjjWrPsNjVrgB8VIkxLudEdQeBOKfCfpd97lEHfZAIYukN51GTcuOF6sgVCS8ZOA74rSx5uNNfSKVFAXtpx/MikANcoefyyuMMU7TuUFgvYHI/r1ImobEYpLfSG0N62wLUmy9GqfFqwTl9uKZx++knL3ZWr1ZnAUlYrzp2Eq91vl59OGjY4qTixVDlJM7n7Jdjv9H9LmdeOkDv+Kq6nLx3EmSbcTNJFwImKubtjrrccF5qRi+yFG15uJneTp4INI6XkQd43flgn8ALqrt9Hyyf/f8C/VYqmfi+0+LrOMcZ8p1/oXgIa5yq/8ALprbyslyBusz5/mtKDGwIy06PLhOLit3DdSz+NYavLhesZXcsgodb5imFJ877twD8aJFgxzPZNi0skqFZjtsj93YOrGq4waC1VxQ16zf4krmVpWgHE592wnz3dI3rFW3rIaBDkJLfKfa4xr6WqiHE+MT0L1xo9PrCSNq3fdfIEBc9XDtUzCVeQO5j4sZINJj/YWGWyadu40M1eoZhA4J6aisTAlIl7Pt9qlVLNF6SvBspbMACuKfHa4FrDfG8hrm1tS7H1KYfqeVdwc4iCq4W7vm/740JdrdLIbeYGKpnK9mjqTdyg13u42aP+BkxkTKAPY1LaxLKEYsrTimX36BqbqGzHKy9wf77xSj1uww0iZ2JooXW4gt7Nupei56xkuiECPiX/OSUwXxuHluImuh+McQGVMOgpQx2dpqA/JSBr44423MYX9+JGYJYrR6nV9QxVMno52c0EM+RuO7BdCPQeAZGSSy3l1oMSwQVcIFQ03MDYdMA9PSnt/6HiVTXxCXJHC4fieiDGK06OlNvw9NMqJdEbg2BcjevNmLh8iUhjO7qfDFDwIuVSSytxpZUU7KKgJrS/BHBiQLOnAnLxMdys0Esx5YtaHT0MNM4XxDNVKIdHZ5/G7ZAy2lhpOJO6TajwuyZWpstVjHILdhG5PdiTlPBN1oVHQb5kL2isoPEwZdZbykiW811HIqgztQVoMEHhzWdLOYe/p94CKnOVKw0k22thq6n+fnya0IIbSdkV5EDU2oKsdowQUjnX1HpCE99JtgQewtv1YqyvVw5VC4uK25q5mu+xZO9nxEwfExO3EjGoMQr+vszE47aOsCAvnP6q98wD/iyIJ/6i/K5Ut+pixhh4abe3nAicJyG+SXZMcm/OFiUCwUzQon4et+9DOoixkeLc47iB4WGKxzZF8B2mZ+IKgBsUFzO1EpAXzkcU8KfL3FNBTIoUi66SgJbhBrvWSLAjYljgvopd55Htgnk/Bgx0hmBsYB+HG0ibY9iHcNuajIQ3HVdBfhV4WfB5oNKRKKC0huMq0kNwO2mlaiWgfqqFTFCOEyKqRQIA14hCT5rXf6HcY7du7KCY8kJ/QfcZYsiXG4Y80YFCSgQE6DgJZa5yve4xROpuQ9zeRnavB89bPo/rtxgg4e4XoFtwzSTbcAXOqibs/Bdfr5gT0jwrDHuQIr7vy0LabvLlF2sByMNKPC+BLwXeimEWaiGYhIkHE5VbXS3vYK/Ln7sNN6k9X3xdXGy2rEJvXN/F6cDfCO3a+LVVgvpdIU9RSEDWSn6Ja5D3JdtVwvYvimEIObRiHFtf+eTZBqqmyN0qDC3E11UzCfOQSg+bZB6hWPplsgXJuL7yBSJclwQkcr5rCYHGaH1+qrHYpKD6LYX4uGIQ1/eDfchoh+/t2iDhdDN0S6HvsTe+VZp4LG6Hqw2Bb/du5QQtzp0SqN1/IKrAavxCjJVHWISbsR0ccHbeZT2vEsgMCSdJbj96psD92nOukOt8h9yOn6OqqQf5Yw/Zgp2PCd3JNuCVu1B2ETYJfh4tDdthOLa00bRLlejeItagLYgLUZ78xeZDnmCdrJrT9WSb3FOB63tNLm8qbtyz1Qi31EQzE+RFvci2CPvr3FNsDYsJyE81bAsY2UG4rpShOkm5YyaZIF9YjWuCnCQ/vyPQVt9ocZUg7SxB2lCTo8D12OLdCbipgmcFdtoCZJZUbetycXxPkd35t9z4ZxPcVhG8X1LSajtRXymWs5UCEjLylTfRvkP0N6oD3asbrpROCYnLU8X6TiLbCxGSsctxzSe/Bn5O7l44kVzzKH3Hx1RTCs/jf38bt/vWXUKdlZYfbKztI2R6Mq5Y1zdgWVYIROysRkBWKx9SvtJmBOcXa4mS14fzoJtKyMhITMUlckshOrQFu3XKt3ZLMLuVc/Qm+3wHTwVF5O5K9RyusLalimsP+xWG4NrGzhfMJkhwU1rLR6myL85ebA/cZMIpgRaGzPUcXJtUaxWoKyQn5yshtERsWITLd1jm3L73JeU7PzCCq+TJXXaB+4lInaXEHNrvALZNsfS6Us5VDtWTkl/ehauqDiB3wixSYnahcpzlhuKPKiBFI5Or/EylhPm4svugIEbF/ViNtT1uLwgkXCQXnS5TKFEMCduMKwLepxLMgEAxPCr8kaiyOzuCLLXWdJhiz5QY9+GtabsW9Hay+01X6vrsMVI1mKNwO3j0LuEzqwSpnyK7oWAlFhPnjj4lBDquQOL9cyX0j5Vbj6qkHtRN7utM0TYtuMY+Wzq2FrMZt8nS/dLgzbTvZS43APvjBClLTyXSu/X9A/X/lQrGvnBXTbLrF7Wn8qYDhDynBjHG9h54EPWgFLZs4FHNlpj2JMepVjKjgBatEjNwF9U1atjWpnKKX5U+bcvC7FHKj2YKGYaw3j6ZZY44uy1UsTF7NZvKJmg/AjhNzMCRgVZZQb0tt/eWQAdU1+oUxfBhYWJcKVCxFnuKoP+JJvaEu0y+r5TjUcXNau6tagGF2ukXokWCusQIKl+b1rWictZSX4PFNkacjJsTOt8Ao/Cpkm1y4Z7grdQ7dJiA4nKBnqp9zCb3UTD+X++nF+MaT54jW9vfW6OQVkn64nrXrsDttWOv3xYVnxBd9XKepLs6za/xowFsZbVV+dAjuBrPWGXX4QYQI5SQjpL7WxOzCB19WDfZJO7vDqHFljyQebHKJjfgRuztjiM1U66OeriGHb/YrrLET8SfjTRstGWnx8niDhL6qaappBLBgKvbzJN7HhIjGP+cictwtaO3algG6VQBxVnUOmXtbyuxG062+Jc2rMGRokEGiVXe2QGCCgVzrEjaK2nfe+Ab7JfhZk9nGwCQKEZ2Vn2he/EZdh8VFD29AOJbKVQ0NxBUpdoaFtJGKck81ZCyITJbI2rmDrLzt532JK7Ofo6qrZiuFRx9Q4TiYTFs+CBcv/dpyi1WEj9dXk7uhOLe1yT48eR2J3lXtgU3kuJ3C2nrDIupJwsK0c50XM3kiALQ/L/lZl40FhU+NSVumMx/1yAF9isVY+xrtoHkMQmwmtJDl7SgMD7ZMcY3xZNtlzU10778cLDY4om48vEmshN+mUBI9mewSNz7laM1k9vP55HZk4oxX8E1VFY6+bBPWFB4NMmN+Mm46UJT/fNoureoBWS3PENgZIS+Zz8Jcyqury+fZT4jd/eMLLNuHsJeb4+KDjm+8crgP0v+dihrkbtwbcVDyRbKKABCXsZViheQW4KvmweA1JuAwgTV7gAyS27KMuGWOU/kEYidKrd84A24KvH7ezvO1GsMKjU+ReLtFuE6VFvIPvwvGYANW6jzAkkaAb4ryHyFqKU95Pa41d1RjxZUjLz0ru88HLM8hty+g1DQ63HbrjyAmw3dUM8WExeYu8KRDrL/X+knKepoEK7cvj9ulH8Urv60VNTMVnJnh6CLPGiqq1hQnEVVMpAFXWzn4a763AVrUVEBcBEmsF3u6MoPxujSC18u3dI4GgJqHA0BNQTUOBoCahwNATUE1DhqdvwRpJPPhdqIYe0AAAAASUVORK5CYII=","customise":"data:image/png;base64,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","text":"data:image/png;base64,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","upload":"data:image/png;base64,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"};
  const icon=k=>iconAssets[k]?'<img class="tw155-design-icon" alt="" aria-hidden="true" decoding="async" draggable="false" src="'+iconAssets[k]+'">':'';
  const customTitle=$('[data-tw15-custom] .tw15-section-title h2');
  if(customTitle && !customTitle.querySelector('.tw155-customise-mark'))customTitle.insertAdjacentHTML('afterbegin','<span class="tw155-customise-mark">'+icon('customise')+'</span>');
  const fingerprintChoice=$('[data-tw-engrave="fingerprint"] .tw-choice-icon img');
  if(fingerprintChoice)fingerprintChoice.src=iconAssets.fingerprint;
  const textChoice=$('[data-tw-engrave="message"] .tw-choice-icon img');
  if(textChoice)textChoice.src=iconAssets.text;
  // Browse the real potential-inlays collection as one image library.
  // Materials are reference selections, not separate cart products.
  const gallery=()=>inlayImages;
  // If Shopify's Liquid collection access returns nothing, try the public
  // products JSON endpoint. This is a display-only material library.
  if(!inlayImages.length && (sideCount>0 || allowMainInlays)){
    const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
    fetch(root+'collections/potential-inlays/products.json?limit=250',{credentials:'same-origin'})
      .then(r=>{if(!r.ok)throw new Error('Inlay gallery '+r.status);return r.json();})
      .then(data=>{
        const found=(data.products||[]).map(p=>({name:p.title,image:p.images?.[0]?.src||p.image?.src})).filter(p=>p.name&&p.image);
        if(found.length){inlayImages=found;renderDesign();}
      }).catch(()=>{});
  }

  const areaName={main:'Ring Face',a:'Ring Left Side',b:'Ring Right Side'};
  // An image type is a design intention, not a completed upload.
  // Material and Text count when selected; Image counts ONLY after uploadSuccess.
  function completed(key){
    if(multiFace && key==='main'){
      return !!(design.faceParts.Material||design.faceParts.Text||
        (design.faceParts.Image && uploadMount.done && uploadMount.completedArea==='main'));
    }
    const pick=design.picks[key];
    if(!pick)return false;
    return pick.kind!=='Image'||(uploadMount.done&&uploadMount.completedArea===key);
  }
  function chosenCount(){return targetKeys.filter(completed).length;}
  function anyDesignIntent(){
    // The Reset action must not appear just because Crest/Image is preselected,
    // a tab was opened, or an artwork type was browsed. An actual completed
    // upload, material, or nonempty text is required.
    return design.route==='now' && chosenCount()>0;
  }
  function isArtwork(){return design.route==='now' && !!design.active && design.category[design.active]==='Image';}
  function storePick(kind,value){if(!design.active)return;design.picks[design.active]={kind,value};}
  function refreshDesignBadges(){
    if(!designRoot)return;
    const n=design.route==='now'?chosenCount():0;
    const status=$('[data-tw15-status]');
    if(status){status.textContent=n?String(n):'OPTIONAL';status.classList.toggle('has-selection',!!n);}
    const reset=$('[data-tw15-reset-all]');
    if(reset)reset.hidden=!anyDesignIntent();
    designRoot.querySelectorAll('[data-tw15-area]').forEach(button=>{
      const done=completed(button.dataset.tw15Area);
      let dot=button.querySelector('.tw15-selected-dot');
      if(done&&!dot)button.insertAdjacentHTML('beforeend','<span class="tw15-selected-dot" aria-label="Selected"></span>');
      if(!done&&dot)dot.remove();
    });
  }
  function uploadSucceeded(){
    const k=uploadMount.pendingArea||design.active;
    if(!targetKeys.includes(k))return;
    uploadMount.pending=false;
    uploadMount.done=true;
    uploadMount.completedArea=k;
    design.artIntent[k]=true;
    if(multiFace && k==='main'){design.faceParts.Image=true;}
    else {design.picks[k]={kind:'Image',value:design.artType[k]||'Crest'};}
    const node=findUploaderyV15();
    if(node)node.classList.add('upload-complete');
    refreshDesignBadges(); // No rerender: preserve the app's live file input.
  }
  function updateInside(){
    const toggle=$('[data-tw15-inside-toggle]'),body=$('[data-tw15-inside-body]');
    if(!toggle||!body)return;
    toggle.setAttribute('aria-expanded',String(insideOpen));body.hidden=!insideOpen;
    const dot=$('[data-tw15-inside-dot]');
    if(dot)dot.hidden=state.engraving==='none';
  }
  function setRoute(route){
    design.route=route==='now'?'now':'later';
    insideOpen=design.route==='later';
    renderDesign();updateInside();
  }
  function renderDesign(){
    if(!designEnabled||!designRoot)return;
    const routeNow=design.route==='now';
    const body=$('[data-tw15-design-body]');body.hidden=!routeNow;
    designRoot.querySelectorAll('[data-tw15-route]').forEach(b=>{
      const on=b.dataset.tw15Route===design.route;b.classList.toggle('is-selected',on);b.setAttribute('aria-pressed',String(on));
    });
    const status=$('[data-tw15-status]');const count=routeNow?chosenCount():0;
    status.textContent=count?String(count):'OPTIONAL';status.classList.toggle('has-selection',!!count);
    const resetAll=$('[data-tw15-reset-all]');if(resetAll)resetAll.hidden=!anyDesignIntent();
    // Reuse the real Uploadery element. Park before replacing content.
    const existing=findUploaderyV15();const parking=$('[data-tw15-upload-parking]');
    if(existing && parking && existing.closest('[data-tw15-options]')){parking.appendChild(existing);existing.hidden=true;}
    if(routeNow){
      const tabs=$('[data-tw15-locations]');
      tabs.innerHTML=targetKeys.map(k=>{
        const isActive=design.active===k,chosen=completed(k);
        return '<button type="button" role="tab" aria-selected="'+isActive+'" class="'+(isActive?'is-active':'')+'" data-tw15-area="'+k+'">'+areaName[k]+(chosen?'<span class="tw15-selected-dot" aria-label="Selected"></span>':'')+'</button>';
      }).join('');
      const k=design.active;if(!k)return;
      if(multiFace && k==='main'){
        const parts=design.faceParts,cat=design.category.main;
        const cats=permittedOptions('main');
        // Independent choices. Opening one does not wipe the other two.
        let html='<div class="tw15-kinds tw159-multi-face" style="--tw15-cols:3">'+cats.map(v=>{
          const picked=v==='Image'?(parts.Image && uploadMount.done && uploadMount.completedArea==='main'):v==='Material'?!!parts.Material:!!parts.Text;
          const viewing=cat===v;
          return '<button type="button" data-tw15-kind="'+v+'" aria-pressed="'+!!picked+'" class="'+(picked?'is-selected':viewing?'is-browsing':'')+'">'+icon(v.toLowerCase())+'<span>'+v+'</span>'+(picked?'<i class="tw159-mini-dot" aria-hidden="true"></i>':'')+'</button>';
        }).join('')+'</div>';
        if(cat==='Material'){
          const items=gallery(),selected=parts.Material;
          const visible=design.expanded.main?items:(selected&&!items.slice(0,3).some(i=>i.name===selected)?items.slice(0,3).concat(items.filter(i=>i.name===selected)):items.slice(0,3));
          html+='<div class="tw15-materials">'+visible.map(i=>'<button type="button" class="tw15-material '+(selected===i.name?'is-selected':'')+'" data-tw15-material="'+esc(i.name)+'" aria-pressed="'+(selected===i.name)+'"><img loading="lazy" src="'+esc(i.image)+'" alt="'+esc(i.name)+'"><span>'+esc(i.name)+'</span></button>').join('')+'</div>';
          if(!items.length)html+='<p class="tw15-muted">No photographed inlays found in the collection.</p>';
          if(items.length>3)html+='<button type="button" class="tw15-view-all" data-tw15-more>'+(design.expanded.main?'Show Less':'View All Inlays')+' <span aria-hidden="true">'+(design.expanded.main?'⌃':'⌄')+'</span></button>';
        } else if(cat==='Image'){
          const typeOpts=['Crest','Fingerprint','Photo'];
          const activeType=typeOpts.includes(design.artType.main)?design.artType.main:'Crest';
          html+='<div class="tw15-artwork-types">'+typeOpts.map(t=>'<button type="button" data-tw15-arttype="'+t+'" class="'+(activeType===t?'is-selected':'')+'" aria-pressed="'+(activeType===t)+'"><span>'+t+'</span></button>').join('')+'</div>';
          html+='<div class="tw155-upload-row">'+icon('upload')+'<div class="tw15-artwork-slot" data-tw15-artwork-slot></div></div>';
        } else if(cat==='Text'){
          html+='<input type="text" maxlength="80" data-tw15-design-text aria-label="Text for Ring Face" placeholder="Enter your text" value="'+esc(parts.Text)+'">';
        }
        // One small way to remove a particular option without resetting the others.
        const chosen=cat==='Image'?!!(parts.Image && uploadMount.done && uploadMount.completedArea==='main'):cat==='Material'?!!parts.Material:cat==='Text'?!!parts.Text:false;
        if(chosen)html+='<div class="tw159-clear-wrap"><button type="button" data-tw159-remove="'+cat+'" aria-label="Remove '+cat+' from ring face">Remove '+cat+'</button></div>';
        $('[data-tw15-options]').innerHTML=html;
      }else{
      const current=design.picks[k];const cat=design.category[k];
      // One, deliberately simple order: Image | Material | Text.
      // Main Material only appears when custom.main_inlays is enabled.
      const categories=permittedOptions(k);
      // Only show a selected design summary after a choice has been made.
      // Category browsing is deliberately quieter than a committed selection.
      let html=current && current.kind===cat && completed(k) ? '<div class="tw15-current"><span>'+esc(current.value)+'</span></div>':'';
      html+='<div class="tw15-kinds" style="--tw15-cols:'+categories.length+'">'+categories.map(v=>{
        const browsing=cat===v;
        const confirmed=browsing && !!current && current.kind===v;
        return '<button type="button" data-tw15-kind="'+v+'" aria-pressed="'+browsing+'" class="'+(confirmed?'is-selected':browsing?'is-browsing':'')+'">'+icon(v.toLowerCase())+'<span>'+v+'</span></button>';
      }).join('')+'</div>';
      if(cat==='Material'&&(k!=='main'||allowMainInlays)){
        const items=gallery(),selected=current&&current.kind===cat?current.value:'';
        const visible=design.expanded[k]?items:(selected&&!items.slice(0,3).some(x=>x.name===selected)?items.slice(0,3).concat(items.filter(x=>x.name===selected)):items.slice(0,3));
        html+='<div class="tw15-materials">'+visible.map(i=>'<button type="button" class="tw15-material '+(selected===i.name?'is-selected':'')+'" data-tw15-material="'+esc(i.name)+'" aria-pressed="'+(selected===i.name)+'"><img loading="lazy" src="'+esc(i.image)+'" alt="'+esc(i.name)+'"><span>'+esc(i.name)+'</span></button>').join('')+'</div>';
        if(!items.length)html+='<p class="tw15-muted">No photographed inlays found in the collection.</p>';
        if(items.length>3)html+='<button type="button" class="tw15-view-all" data-tw15-more>'+(design.expanded[k]?'Show Less':'View All Inlays')+' <span aria-hidden="true">'+(design.expanded[k]?'⌃':'⌄')+'</span></button>';
      }else if(cat==='Image'){
        const typeOpts=['Crest','Fingerprint','Photo'].filter(t=>canUse('image')||canUse(t.toLowerCase())||k==='main');
        // Crest is visually preselected without marking this area as completed.
        // All three type buttons are text-only (no Fingerprint icon).
        const activeType=typeOpts.includes(design.artType[k])?design.artType[k]:(typeOpts[0]||'Crest');
        html+='<div class="tw15-artwork-types">'+typeOpts.map(t=>'<button type="button" data-tw15-arttype="'+t+'" class="'+(activeType===t?'is-selected':'')+'" aria-pressed="'+(activeType===t)+'"><span>'+t+'</span></button>').join('')+'</div>';
        html+='<div class="tw155-upload-row">'+icon('upload')+'<div class="tw15-artwork-slot" data-tw15-artwork-slot></div></div>';
      }else if(cat==='Text'){
        html+='<input type="text" maxlength="80" data-tw15-design-text aria-label="Custom design text" placeholder="Enter your text" value="'+esc(design.notes[k]||'')+'">';
      }
      $('[data-tw15-options]').innerHTML=html;
      }
    }
    positionUploaderyV15();
  }
  if(designRoot){
    designRoot.hidden=!(designEnabled&&targetKeys.length>0);
    if(designEnabled && targetKeys.length){
      designRoot.addEventListener('click',e=>{
        const b=e.target.closest('button');if(!b||!designRoot.contains(b))return;
        if(b.dataset.tw15Route){setRoute(b.dataset.tw15Route);return;}
        if(b.dataset.tw15Area){design.active=b.dataset.tw15Area;renderDesign();return;}
        if(b.dataset.tw15Kind){const v=b.dataset.tw15Kind;
          if(multiFace&&design.active==='main'){
            design.category.main=v;
            design.expanded.main=false;
            if(v==='Image') {design.faceParts.Image=true;design.artIntent.main=true;}
            renderDesign();return;
          }
          if(design.category[design.active]!==v){
            // Browsing another type must NOT erase a previously saved choice.
            // It is replaced only after the customer chooses a new material, image, or text.
            design.category[design.active]=v;design.expanded[design.active]=false;
            if(v==='Image')design.artIntent[design.active]=true;
          }
          renderDesign();return;
        }
        if(b.dataset.tw159Remove && multiFace && design.active==='main'){
          const part=b.dataset.tw159Remove;
          if(part==='Image') {design.faceParts.Image=false;design.artIntent.main=false;}
          if(part==='Material') design.faceParts.Material='';
          if(part==='Text') design.faceParts.Text='';
          renderDesign();return;
        }
        if(b.hasAttribute('data-tw15-reset-all')){
          if(multiFace){design.faceParts={Image:false,Material:'',Text:''};}
          // Reset design choices across all active ring areas.
          // Inside engraving, paid extras, and uploaded files are not modified.
          targetKeys.forEach(k=>{
            design.picks[k]=null;design.notes[k]='';design.expanded[k]=false;
            design.category[k]=initialCategory(k);
            design.artType[k]='Crest';design.artIntent[k]=false;
          });
          renderDesign();return;
        }
        if(b.dataset.tw15Material){
          if(multiFace && design.active==='main')design.faceParts.Material=b.dataset.tw15Material;
          else storePick(design.category[design.active],b.dataset.tw15Material);
          renderDesign();return;
        }
        if(b.hasAttribute('data-tw15-more')){design.expanded[design.active]=!design.expanded[design.active];renderDesign();return;}
        if(b.dataset.tw15Arttype){
          const k=design.active;design.artType[k]=b.dataset.tw15Arttype;design.artIntent[k]=true;
          if(multiFace&&k==='main')design.faceParts.Image=true;
          else storePick('Image',b.dataset.tw15Arttype);
          renderDesign();return;
        }
      });
      designRoot.addEventListener('input',e=>{
        if(!e.target.matches('[data-tw15-design-text]'))return;
        const k=design.active;design.notes[k]=e.target.value;
        if(multiFace && k==='main')design.faceParts.Text=e.target.value.trim();
        else if(e.target.value.trim())storePick('Text',e.target.value.trim());else design.picks[k]=null;
        refreshDesignBadges();
        // Reflect changed text selection without replacing the active input.
        if(multiFace && k==='main'){
          const btn=designRoot.querySelector('[data-tw15-kind="Text"]');
          if(btn){btn.classList.toggle('is-selected',!!design.faceParts.Text);btn.setAttribute('aria-pressed',String(!!design.faceParts.Text));}
        }
      });
      renderDesign();
    }
  }
  const insideToggle=$('[data-tw15-inside-toggle]');
  if(insideToggle)insideToggle.addEventListener('click',()=>{insideOpen=!insideOpen;updateInside();});

  function customPropertiesV15(){
    if(!designEnabled||!targetKeys.length)return {};
    if(design.route==='later')return {'Design customisation':'Discuss After Order'};
    const props={'Design customisation':'Customise Now'};
    targetKeys.forEach(k=>{
      if(multiFace && k==='main'){
        const p=design.faceParts;
        if(p.Image){
          props['Ring Face image']=design.artType.main||'Crest';
          props['Ring Face artwork']=(uploadMount.done && uploadMount.completedArea==='main')?'Uploaded via Uploadery':'To discuss or supply after checkout';
        }
        if(p.Material)props['Ring Face material']=p.Material;
        if(p.Text)props['Ring Face text']=p.Text;
        return;
      }
      const p=design.picks[k];
      const name=k==='main'?'Ring Face':k==='a'?'Ring Left Side':'Ring Right Side';
      if(p){
        props[name+' type']=p.kind;props[name+' selection']=p.value;
        if(p.kind==='Image')props[name+' artwork']=completed(k)?'Uploaded via Uploadery':'To discuss or supply after checkout';
      }else if(design.artIntent[k]&&design.category[k]==='Image'){
        // Image/Crest can be ordered without uploading a file.
        props[name+' type']='Image';props[name+' selection']=design.artType[k]||'Crest';
        props[name+' artwork']='To discuss or supply after checkout';
      }
    });
    return props;
  }
  // Uploadery app owns the existing input/form. The builder moves, never clones it.
  function findUploaderyV15(){
    if(uploadMount.node?.isConnected)return uploadMount.node;
    const node=document.querySelector('#uploadery-container');
    if(!node||!node.querySelector('form[data-uploadery]'))return null;
    uploadMount.node=node;return node;
  }
  function positionUploaderyV15(){
    // The Standard profile shows inside engraving only. Keep the Uploadery
    // app installed but do not expose a standalone uploader on this product.
    if(!designEnabled){
      const standalone=document.querySelector('#uploadery-container');
      if(standalone)standalone.hidden=true;
      return;
    }
    bindShoppadUploadEvents();
    const node=findUploaderyV15();if(!node)return;
    const slot=isArtwork()?designRoot.querySelector('[data-tw15-artwork-slot]'):null;
    const destination=slot||$('[data-tw15-upload-parking]');if(!destination)return;
    if(node.parentNode!==destination)destination.appendChild(node);
    node.classList.add('tw15-uploadery');node.hidden=!slot;
  }
  document.addEventListener('change',e=>{
    const node=findUploaderyV15();
    if(node && e.target.matches?.('input[type="file"]') && node.contains(e.target)){
      uploadMount.done=false;uploadMount.pending=!!e.target.files?.length;
      uploadMount.pendingArea=design.active;uploadMount.completedArea=null;
      node.classList.remove('upload-complete');
      refreshDesignBadges();
    }
  },true);
  document.addEventListener('uploadSuccess',e=>{
    const node=findUploaderyV15();if(node&&(e.target===node||node.contains(e.target)||e.target.closest?.('#uploadery-container')===node)){
      uploadSucceeded();
    }
  },true);
  // Uploadery emits a Shoppad/jQuery custom event on some theme versions.
  // Handle that as well as native DOM events to prevent "uploading" getting stuck.
  function bindShoppadUploadEvents(){
    const jq=window.Shoppad && window.Shoppad.$;
    if(shoppadHandlerBound || typeof jq!=='function')return;
    jq(document).on('uploadSuccess.tw157', 'form[data-uploadery]', function(){
      const node=findUploaderyV15();
      if(node && node.contains(this)){
        uploadSucceeded();
      }
    });
    shoppadHandlerBound=true;
  }
  document.addEventListener('uploadError',e=>{
    const node=findUploaderyV15();if(node && (e.target===node || node.contains(e.target)))uploadMount.pending=false;
  },true);
  if(typeof MutationObserver!=='undefined'&&!designEnabled){
    const observer=new MutationObserver(()=>{
      const node=document.querySelector('#uploadery-container');
      if(node && !node.hidden)node.hidden=true;
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
  if(typeof MutationObserver!=='undefined'&&designEnabled){
    const obs=new MutationObserver(()=>{
      const node=findUploaderyV15();if(!node)return;
      const target=isArtwork()?designRoot.querySelector('[data-tw15-artwork-slot]'):$('[data-tw15-upload-parking]');
      if(target && target!==node.parentNode)positionUploaderyV15();
    });
    obs.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',positionUploaderyV15);
  else positionUploaderyV15();
  function uploadedProperties(){
    const node=findUploaderyV15();if(!node)return {};
    const props={};
    node.querySelectorAll('[name^="properties["]').forEach(input=>{
      const match=input.name.match(/^properties\[(.+)\]$/);const value=String(input.value||'').trim();
      if(match&&value&&/^https?:\/\//.test(value))props['Artwork upload · '+match[1]]=value;
    });
    return props;
  }

  const size = $('[data-tw-size]');

  const message = $('[data-tw-message]');

  const warranty = $('[data-tw-warranty]');

  const atc = $('[data-tw-atc]');

  const error = $('[data-tw-error]');

  const extrasStatus = $('[data-tw-extras-status]');

  const sizeFinder = $('[data-tw-size-finder]');
  const sizeFinderToggle = $('[data-tw-size-finder-toggle]');
  const sizeFinderClose = $('[data-tw-size-finder-close]');
  const diameterInput = $('[data-tw-diameter]');
  const circumferenceInput = $('[data-tw-circumference]');
  const sizeResult = $('[data-tw-size-result]');
  const sizeResultSize = $('[data-tw-size-result-size]');
  const sizeResultDetail = $('[data-tw-size-result-detail]');
  const sizeUse = $('[data-tw-size-use]');

  let recommendedSize = '';
  let recommendedVariantId = '';


  const money = cents => new Intl.NumberFormat('en-ZA', {

    style:'currency',

    currency:'ZAR',

    minimumFractionDigits:2,

    maximumFractionDigits:2

  }).format((cents || 0) / 100).replace(/\u00a0/g,' ');


  const ring = () => config.product.variants.find(v => String(v.id) === size.value);

  const addon = key => A[key] || {id:0,price:0,available:false};

  const count = () => Array.from(message.value.trim()).length;

  const selectedBoxKey = () => {

    if(!state.boxEnabled) return '';

    if(state.boxChoice === 'plain') return 'box_plain';

    if(state.boxChoice === 'fingerprint') return 'box_fingerprint';

    if(state.boxChoice === 'photo') return 'box_photo';

    return '';

  };


  const extras = () => {

    let v = 0;

    if(state.engraving === 'message') v += addon('message').price * count();

    if(state.engraving === 'fingerprint') v += addon('fingerprint').price;

    if(state.warranty) v += addon('warranty').price;

    const boxKey = selectedBoxKey();

    if(boxKey) v += addon(boxKey).price;

    return v;

  };


  const total = () => ((ring()?.price || 0) + extras()) * state.quantity;


  function report(text){

    error.textContent = text || '';

    error.hidden = !text;

    if(text) error.scrollIntoView({behavior:'smooth',block:'nearest'});

  }


  function choose(selector, attr, value){

    $$(selector).forEach(btn => {

      const active = btn.getAttribute(attr) === value;

      btn.classList.toggle('is-selected', active);

      btn.setAttribute('aria-pressed', String(active));

    });

  }


  function updateExtrasStatus(){

    const names = [];

    let amount = 0;

    let needsFingerprint = false;

    let needsImage = false;


    if(state.engraving === 'message' && count() > 0){

      names.push('Message engraving');

      amount += addon('message').price * count();

    } else if(state.engraving === 'fingerprint'){

      names.push('Fingerprint');

      amount += addon('fingerprint').price;

      needsFingerprint = true;

    }


    if(state.warranty){

      names.push('Warranty');

      amount += addon('warranty').price;

    }


    const boxKey = selectedBoxKey();

    if(boxKey === 'box_plain'){

      names.push('Keepsake box');

      amount += addon('box_plain').price;

    } else if(boxKey === 'box_fingerprint'){

      names.push('Fingerprint box');

      amount += addon('box_fingerprint').price;

      needsFingerprint = true;

    } else if(boxKey === 'box_photo'){

      names.push('Photo box');

      amount += addon('box_photo').price;

      needsImage = true;

    }


    const hasExtras = names.length > 0;

    extrasStatus.classList.toggle('has-extras', hasExtras);


    const statusText = $('[data-tw-extras-status-text]');

    const statusTotal = $('[data-tw-extras-status-total]');

    const instruction = $('[data-tw-extras-instruction]');

    const clearBtn = $('[data-tw-clear-extras]');


    if(hasExtras){

      if(names.length === 1){

        statusText.textContent = `${names[0]} added`;

      } else {

        statusText.textContent = `${names.length} extras added`;

      }

      statusTotal.textContent = `+${money(amount)}`;

      clearBtn.hidden = false;


      let instructionText = '';

      if(needsFingerprint && needsImage){

        instructionText = 'Send fingerprint / image on WhatsApp after checkout.';

      } else if(needsFingerprint){

        instructionText = 'Send fingerprint on WhatsApp after checkout.';

      } else if(needsImage){

        instructionText = 'Send image on WhatsApp after checkout.';

      }


      instruction.textContent = instructionText;

      instruction.hidden = !instructionText;

    } else {

      statusText.textContent = '';

      statusTotal.textContent = '';

      clearBtn.hidden = true;

      instruction.textContent = '';

      instruction.hidden = true;

    }

  }


  const ringSizeChart = [
    ['H',14.97],['H½',15.10],['I',15.27],['I½',15.40],['J',15.49],['J½',15.70],
    ['K',15.90],['K½',16.10],['L',16.31],['L½',16.51],['M',16.71],['M½',16.92],
    ['N',17.12],['N½',17.32],['O',17.53],['O½',17.73],['P',17.93],['P½',18.14],
    ['Q',18.34],['Q½',18.55],['R',18.75],['R½',18.95],['S',19.15],['S½',19.35],
    ['T',19.56],['T½',19.76],['U',19.96],['U½',20.17],['V',20.37],['V½',20.58],
    ['W',20.78],['W½',20.98],['X',21.18],['X½',21.39],['Y',21.59],['Y½',21.79],
    ['Z',21.99],['Z½',22.20]
  ];

  function normaliseSizeToken(text){
    return String(text || '')
      .toUpperCase()
      .replace(/SIZE|RING|UK|SA|SOUTH AFRICAN|\(|\)|\-|_/g,' ')
      .replace(/1\/2/g,'½')
      .replace(/\.5/g,'½')
      .replace(/\s+/g,' ')
      .trim();
  }

  function findVariantForSize(label){
    const target = normaliseSizeToken(label).replace(/\s/g,'');
    const candidates = Array.from(size.options).filter(o => !o.disabled);

    let exact = candidates.find(o => {
      const text = normaliseSizeToken(o.textContent).replace(/\s/g,'');
      return text === target || text === `SIZE${target}`;
    });
    if(exact) return exact;

    exact = candidates.find(o => {
      const text = normaliseSizeToken(o.textContent);
      const tokens = text.split(' ').map(v => v.replace(/\s/g,''));
      return tokens.includes(target);
    });
    return exact || null;
  }

  function closestRingSize(diameter){
    if(!Number.isFinite(diameter)) return null;
    return ringSizeChart.reduce((best,current) => {
      return Math.abs(current[1] - diameter) < Math.abs(best[1] - diameter) ? current : best;
    }, ringSizeChart[0]);
  }

  function updateSizeRecommendation(mode){
    let diameter = NaN;
    let sourceValue = NaN;

    if(mode === 'finger'){
      sourceValue = parseFloat(circumferenceInput?.value || '');
      diameter = sourceValue / Math.PI;
    } else {
      sourceValue = parseFloat(diameterInput?.value || '');
      diameter = sourceValue;
    }

    const sensible = mode === 'finger'
      ? Number.isFinite(sourceValue) && sourceValue >= 44 && sourceValue <= 80
      : Number.isFinite(sourceValue) && sourceValue >= 14 && sourceValue <= 25;

    if(!sensible){
      recommendedSize = '';
      recommendedVariantId = '';
      if(sizeResult) sizeResult.hidden = true;
      return;
    }

    const match = closestRingSize(diameter);
    if(!match) return;

    recommendedSize = match[0];
    const variantOption = findVariantForSize(recommendedSize);
    recommendedVariantId = variantOption ? variantOption.value : '';

    sizeResultSize.textContent = recommendedSize;
    sizeResultDetail.textContent = `${match[1].toFixed(1)} mm diameter · ${(match[1] * Math.PI).toFixed(1)} mm circumference`;
    sizeUse.disabled = !variantOption;
    sizeUse.textContent = variantOption ? `USE SIZE ${recommendedSize}` : 'SELECT CLOSEST SIZE ABOVE';
    sizeResult.hidden = false;
  }

  function openSizeFinder(scroll=true){
    if(!sizeFinder) return;
    sizeFinder.hidden = false;
    sizeFinderToggle?.setAttribute('aria-expanded','true');
    if(scroll) sizeFinder.scrollIntoView({behavior:'smooth',block:'nearest'});
  }

  function closeSizeFinder(){
    if(!sizeFinder) return;
    sizeFinder.hidden = true;
    sizeFinderToggle?.setAttribute('aria-expanded','false');
  }

  function selectSizeMethod(method){
    $$('[data-tw-size-method]').forEach(btn => {
      const active = btn.dataset.twSizeMethod === method;
      btn.classList.toggle('is-selected',active);
      btn.setAttribute('aria-pressed',String(active));
    });
    $$('[data-tw-size-panel]').forEach(panel => {
      panel.hidden = panel.dataset.twSizePanel !== method;
    });
    updateSizeRecommendation(method);
  }

  function refresh(){

    const r = ring();

    const limits = r?.quantity_rule || {};

    const min = Math.max(1, limits.min || 1);

    const step = Math.max(1, limits.increment || 1);

    const max = limits.max || 999;


    if(state.quantity < min) state.quantity = min;

    if(state.quantity > max) state.quantity = max;


    $('[data-tw-qty]').textContent = state.quantity;

    $('[data-tw-minus]').disabled = state.busy || state.quantity <= min;

    $('[data-tw-plus]').disabled = state.busy || state.quantity + step > max;


    $('[data-tw-price]').textContent = money(r?.price || 0);


    const compare = Number(r?.compare_at_price || 0);

    const price = Number(r?.price || 0);

    const onSale = compare > price;


    $('[data-tw-sale-line]').hidden = !onSale;

    $('[data-tw-save]').hidden = !onSale;

    if(onSale){

      $('[data-tw-compare]').textContent = money(compare);

      $('[data-tw-save]').textContent = `SAVE ${money(compare - price)}`;

    }


    $('[data-tw-total]').textContent = money(total());

    $('[data-tw-stitch]').textContent = money(total() / 6);

    const payStitch3 = $('[data-tw-pay-stitch3]');
    const payStitch6 = $('[data-tw-pay-stitch6]');
    const payCard = $('[data-tw-pay-card]');

    if(payStitch3) payStitch3.textContent = money(total() / 3);
    if(payStitch6) payStitch6.textContent = money(total() / 6);
    if(payCard) payCard.textContent = money(total());

    const payStitch3Tab = $('[data-tw-pay-stitch3-tab]');
    const payStitch6Tab = $('[data-tw-pay-stitch6-tab]');
    const payCardTab = $('[data-tw-pay-card-tab]');

    if(payStitch3Tab) payStitch3Tab.textContent = money(total() / 3);
    if(payStitch6Tab) payStitch6Tab.textContent = money(total() / 6);
    if(payCardTab) payCardTab.textContent = money(total());


    const stock = $('[data-tw-stock]');

    const available = Boolean(r?.available);

    stock.innerHTML = available ? '<i></i>Available to order' : '<i></i>Sold out';

    stock.classList.toggle('is-sold', !available);


    $('[data-tw-message-panel]').hidden = state.engraving !== 'message';
    updateInside();


    $$('[data-tw-preview]').forEach(node => { node.textContent = message.value.trim() || 'Forever Yours'; });
    $('[data-tw-count]').textContent = count();

    $('[data-tw-message-meta]').textContent = count() > 0

      ? `Added · ${count()} ${count() === 1 ? 'character' : 'characters'}`

      : '0 characters';

    $('[data-tw-message-total]').textContent = count() > 0

      ? money(addon('message').price * count())

      : '';

    if(warranty) warranty.checked = state.warranty;

const boxToggle = $('[data-tw-box-toggle]');

    const boxCard = $('[data-tw-box-card]');

    const boxOptions = $('[data-tw-box-options]');

    const boxChoiceCopy = $('[data-tw-box-choice-copy]');


    if(boxToggle) boxToggle.checked = state.boxEnabled;

    if(boxCard) boxCard.classList.toggle('is-open', state.boxEnabled);

    if(boxOptions) boxOptions.setAttribute('aria-hidden', String(!state.boxEnabled));


    if(boxChoiceCopy){

      const labels = {

        plain: 'Plain selected',

        fingerprint: 'Fingerprint selected',

        photo: 'Photo selected'

      };

      boxChoiceCopy.textContent = labels[state.boxChoice] || 'Plain selected';

    }


    $$('[data-tw-box-choice]').forEach(btn => {

      const active = state.boxEnabled && btn.getAttribute('data-tw-box-choice') === state.boxChoice;

      btn.classList.toggle('is-selected', active);

      btn.setAttribute('aria-pressed', String(active));

    });


    updateExtrasStatus();


    atc.disabled = !available || state.busy;

    atc.dataset.loading = String(state.busy);

    $('[data-tw-atc-text]').textContent = state.busy ? 'ADDING…' : available ? 'ADD TO CART' : 'SOLD OUT';


    const phone = el.dataset.whatsapp.replace(/[^\d]/g,'');

    const txt = `Hi Touchwood! I have a custom ring design idea for ${config.product.title}.`;

    $('[data-tw-whatsapp]').href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(txt)}` : '#';

  }


  if(sizeFinderToggle){
    sizeFinderToggle.addEventListener('click', () => {
      if(sizeFinder.hidden) openSizeFinder(false);
      else closeSizeFinder();
    });
  }

  if(sizeFinderClose) sizeFinderClose.addEventListener('click', closeSizeFinder);

  $$('[data-tw-size-method]').forEach(btn => btn.addEventListener('click', () => {
    selectSizeMethod(btn.dataset.twSizeMethod);
  }));

  if(diameterInput){
    diameterInput.addEventListener('input', () => updateSizeRecommendation('ring'));
  }

  if(circumferenceInput){
    circumferenceInput.addEventListener('input', () => updateSizeRecommendation('finger'));
  }

  if(sizeUse){
    sizeUse.addEventListener('click', () => {
      if(!recommendedVariantId) return;
      size.value = recommendedVariantId;
      size.dispatchEvent(new Event('change',{bubbles:true}));
      size.focus({preventScroll:true});
      size.closest('.tw-size')?.scrollIntoView({behavior:'smooth',block:'nearest'});
    });
  }


  size.addEventListener('change', () => {

    state.quantity = ring()?.quantity_rule?.min || 1;

    try {

      const u = new URL(location.href);

      u.searchParams.set('variant', size.value);

      history.replaceState(history.state, '', u);

    } catch(e) {}

    report('');

    refresh();

  });


  $$('[data-tw-engrave]').forEach(btn => btn.addEventListener('click', () => {

    state.engraving = btn.dataset.twEngrave;

    choose('[data-tw-engrave]', 'data-tw-engrave', state.engraving);

    report('');

    refresh();

  }));


  message.addEventListener('input', () => {

    report('');

    refresh();

  });


  $$('[data-tw-font]').forEach(btn => btn.addEventListener('click', () => {

    state.font = btn.dataset.twFont;

    choose('[data-tw-font]', 'data-tw-font', state.font);

    refresh();

  }));


  if(warranty){

    warranty.addEventListener('change', () => {

      state.warranty = warranty.checked;

      report('');

      refresh();

    });

  }


  $('[data-tw-minus]').addEventListener('click', () => {

    const q = ring()?.quantity_rule || {};

    state.quantity = Math.max(q.min || 1, state.quantity - (q.increment || 1));

    refresh();

  });


  $('[data-tw-plus]').addEventListener('click', () => {

    const q = ring()?.quantity_rule || {};

    state.quantity = Math.min(q.max || 999, state.quantity + (q.increment || 1));

    refresh();

  });


  $('[data-tw-clear-extras]').addEventListener('click', () => {

    state.engraving = 'none';

    state.font = 'Quicksand Light';

    state.warranty = false;

    state.boxEnabled = false;

    state.boxChoice = 'plain';

    message.value = '';

    if(warranty) warranty.checked = false;

    choose('[data-tw-engrave]', 'data-tw-engrave', 'none');

    choose('[data-tw-font]', 'data-tw-font', 'Quicksand Light');

    report('');

    refresh();

  });


  const boxToggle = $('[data-tw-box-toggle]');

  if(boxToggle){

    boxToggle.addEventListener('change', () => {

      state.boxEnabled = boxToggle.checked;

      if(state.boxEnabled && !state.boxChoice) state.boxChoice = 'plain';

      report('');

      refresh();

    });

  }


  $$('[data-tw-box-choice]').forEach(btn => btn.addEventListener('click', () => {

    state.boxEnabled = true;

    state.boxChoice = btn.dataset.twBoxChoice;

    report('');

    refresh();

  }));


  $$('[data-tw-open-info]').forEach(btn => btn.addEventListener('click', () => {
    const target = btn.dataset.twOpenInfo;
    const tab = el.querySelector(`[data-tw-info-tab="${target}"]`);
    if(tab){
      tab.click();
      el.querySelector('[data-tw-info-tabs]')?.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }));

  $('[data-tw-whatsapp]').addEventListener('click', e => {

    if(el.dataset.whatsapp.replace(/[^\d]/g,'').length < 9){

      e.preventDefault();

      report('WhatsApp is not configured yet.');

    }

  });


  function verify(){

    if(uploadMount.pending && !uploadMount.done)return 'Please wait for your artwork upload to finish.';

    const r = ring();

    if(!r?.available) return 'This ring size is currently unavailable.';

    if(state.engraving === 'message' && !count()) return 'Please enter your engraving message.';

    if(state.engraving !== 'none' && !addon(state.engraving).available) return 'The selected personalisation is currently unavailable.';

    if(state.warranty && !addon('warranty').available) return 'The warranty upgrade is currently unavailable.';

    const boxKey = selectedBoxKey();

    if(boxKey && !addon(boxKey).available) return 'The selected keepsake box option is currently unavailable.';

    return '';

  }


  function buildItems(){

    const bundle = `TW-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,7)}`;


    const properties = {

      'Ring size': ring().title,

      'Engraving': state.engraving === 'none' ? 'None' : state.engraving === 'message' ? 'Message' : 'Fingerprint',

      'Lifetime warranty': state.warranty ? 'Yes' : 'No',

      'Keepsake box': selectedBoxKey() === 'box_plain' ? 'Plain' : selectedBoxKey() === 'box_fingerprint' ? 'Fingerprint' : selectedBoxKey() === 'box_photo' ? 'Photo' : 'None',

      '_Touchwood bundle': bundle

    };


    if(state.engraving === 'message'){

      properties['Engraving message'] = message.value.trim();

      properties['Engraving font'] = state.font;

    }


    if(state.engraving === 'fingerprint'){

      properties['Image submission'] = 'Provide fingerprint artwork or discuss after checkout';

    }


    Object.assign(properties, customPropertiesV15(), uploadedProperties());

    const items = [{

      id:Number(ring().id),

      quantity:state.quantity,

      properties

    }];


    const shared = {

      'For ring':config.product.title,

      '_Touchwood bundle':bundle

    };


    const push = (key, qty, details={}) => {

      if(qty > 0){

        items.push({

          id:Number(addon(key).id),

          quantity:qty,

          properties:{...shared,...details}

        });

      }

    };


    if(state.engraving === 'message'){

      push('message', count() * state.quantity, {

        'Engraving message':message.value.trim(),

        'Engraving font':state.font

      });

    }


    if(state.engraving === 'fingerprint'){

      push('fingerprint', state.quantity, {

        'Image submission':'Provide fingerprint artwork or discuss after checkout'

      });

    }


    if(state.warranty){

      push('warranty', state.quantity);

    }


    const boxKey = selectedBoxKey();

    if(boxKey === 'box_plain'){

      push('box_plain', state.quantity, {

        'Keepsake box': 'Plain'

      });

    } else if(boxKey === 'box_fingerprint'){

      push('box_fingerprint', state.quantity, {

        'Keepsake box': 'Fingerprint',

        'Image submission':'Provide box artwork or discuss after checkout'

      });

    } else if(boxKey === 'box_photo'){

      push('box_photo', state.quantity, {

        'Keepsake box': 'Photo',

        'Image submission':'Provide box artwork or discuss after checkout'

      });

    }


    return items;

  }


  atc.addEventListener('click', async () => {

    if(state.busy) return;


    const issue = verify();

    if(issue){

      report(issue);

      return;

    }


    report('');

    state.busy = true;

    refresh();


    const root = window.Shopify?.routes?.root || '/';

    const sections = [];


    try {

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {

        bubbles:true,

        detail:{sections}

      }));


      const payload = {

        items:buildItems(),

        sections:[...new Set(sections)].join(','),

        sections_url:location.pathname

      };


      const response = await fetch(root + 'cart/add.js', {

        method:'POST',

        headers:{

          'Content-Type':'application/json',

          'X-Requested-With':'XMLHttpRequest'

        },

        body:JSON.stringify(payload)

      });


      const json = await response.json();

      if(!response.ok){

        throw new Error(json.description || json.message || 'Unable to add the selection to your cart.');

      }


      if(

        window.themeVariables?.settings?.cartType === 'page' ||

        window.themeVariables?.settings?.pageType === 'cart'

      ){

        location.href = root + 'cart';

        return;

      }


      const cartResponse = await fetch(root + 'cart.js');

      if(!cartResponse.ok) throw new Error('Cart added, but could not refresh the cart.');


      const cart = await cartResponse.json();

      cart.sections = json.sections || {};


      const missing = sections.some(s => !cart.sections[s]);

      if(missing){

        location.href = root + 'cart';

        return;

      }


      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {

        bubbles:true,

        detail:{

          baseEvent:'variant:add',

          onSuccessDo:'force_open_drawer',

          cart

        }

      }));


      if(!sections.length){

        document.dispatchEvent(new CustomEvent('cart:refresh'));

      }


    } catch(e) {

      console.error('Touchwood builder cart:', e);

      report(e.message || 'Something went wrong. Please try again.');

    } finally {

      state.busy = false;

      refresh();

    }

  });


  const list = el.closest('.product-info__block-list');


  if(list){

    const moveLooxRatingIntoCard = () => {
      const slot = $('[data-tw-rating-slot]');
      if(!slot) return false;

      /* Loox markup varies by app version. Match the rating itself rather than
         relying on the older data-widget="rating" attribute. */
      const rating = list.querySelector('.product-info__block-item[data-block-type="@app"] .loox-rating');
      if(!rating) return false;

      const block = rating.closest('.product-info__block-item');
      if(!block) return false;

      if(block.parentElement !== slot) slot.appendChild(block);
      return true;
    };

    if(!moveLooxRatingIntoCard()){
      const ratingObserver = new MutationObserver(() => {
        if(moveLooxRatingIntoCard()) ratingObserver.disconnect();
      });
      ratingObserver.observe(list,{childList:true,subtree:true});
      window.setTimeout(() => ratingObserver.disconnect(),8000);
    }


    const snippets = list.querySelector('.product-info__block-item[data-block-type="@app"] loox-snippets-widget');

    if(snippets){

      const block = snippets.closest('.product-info__block-item');

      const slot = $('[data-tw-review-slot]');

      if(block && slot) slot.appendChild(block);

    }


    list.classList.add('tw-builder-active');

  }


  el.dataset.initialised = 'yes';

  refresh();

})();




(function(){
  'use strict';

  const root = document.querySelector('.tw-builder [data-tw-info-tabs]');
  if(!root || root.dataset.ready === 'yes') return;

  const source = root.querySelector('[data-tw-description-source]');
  const sizingSource = root.querySelector('[data-tw-sizing-source]');
  const descriptionTarget = root.querySelector('[data-tw-info-description]');
  const materialsTarget = root.querySelector('[data-tw-info-materials]');
  const sizingTarget = root.querySelector('[data-tw-info-sizing]');

  const clean = value => String(value || '').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim();
  const normal = value => clean(value).toLowerCase().replace(/[.:]+$/,'').trim();

  const temp = document.createElement('div');
  temp.innerHTML = source?.innerHTML || '';

  const descriptionNodes = [];
  const featureNodes = [];
  let mode = 'description';

  const detectSection = node => {
    const text = normal(node.textContent);
    if(!text) return null;

    if([
      'key features',
      'features',
      'product features',
      'details & materials',
      'details and materials',
      'specifications',
      'specs'
    ].includes(text)) return 'features';

    if([
      'ring sizing',
      'ring size',
      'sizing',
      'sizing guide',
      'size guide',
      'lifetime warranty',
      'warranty',
      'warranty & care',
      'warranty and care',
      'customer reviews',
      'reviews'
    ].includes(text)) return 'stop';

    return null;
  };

  Array.from(temp.children).forEach(node => {
    const section = detectSection(node);

    if(section === 'features'){
      mode = 'features';
      return;
    }

    if(section === 'stop'){
      mode = 'stop';
      return;
    }

    if(mode === 'description'){
      const txt = normal(node.textContent);
      if(txt !== 'description' && node.tagName?.toLowerCase() !== 'h1'){
        descriptionNodes.push(node);
      }
    }

    if(mode === 'features'){
      featureNodes.push(node);
    }
  });

  const frag = document.createDocumentFragment();
  descriptionNodes.forEach(node => frag.appendChild(node.cloneNode(true)));
  descriptionTarget.appendChild(frag);

  const specs = [];

  const addSpec = raw => {
    const text = clean(raw);
    if(!text) return;

    const colon = text.indexOf(':');
    if(colon <= 0) return;

    const label = clean(text.slice(0,colon));
    const value = clean(text.slice(colon + 1));

    if(!label || !value || label.length > 40) return;
    specs.push({label,value});
  };

  featureNodes.forEach(node => {
    const lis = node.querySelectorAll?.('li') || [];

    if(lis.length){
      lis.forEach(li => addSpec(li.textContent));
      return;
    }

    (node.innerText || node.textContent || '')
      .split(/\n/)
      .map(clean)
      .filter(Boolean)
      .forEach(addSpec);
  });

  const order = [
    'metal','material','texture','finish','colour','color',
    'inlay','width','protective epoxy','epoxy','fit','ring fit'
  ];

  const seen = new Set();

  const unique = specs.filter(item => {
    const key = normal(item.label);
    if(seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  const rank = item => {
    const label = normal(item.label);
    const exact = order.indexOf(label);
    if(exact !== -1) return exact;

    const partial = order.findIndex(key => label.includes(key));
    return partial === -1 ? 999 : partial;
  };

  unique.sort((a,b) => rank(a) - rank(b));

  unique.forEach(item => {
    const row = document.createElement('div');
    row.className = 'tw-spec-row';

    const label = document.createElement('span');
    label.className = 'tw-spec-label';
    label.textContent = item.label;

    const value = document.createElement('span');
    value.className = 'tw-spec-value';
    value.textContent = item.value;

    row.append(label,value);
    materialsTarget.appendChild(row);
  });

  if(!descriptionTarget.textContent.trim()){
    descriptionTarget.innerHTML = source?.innerHTML || '';
  }

  if(!unique.length){
    materialsTarget.innerHTML = '<div class="tw-spec-row"><span class="tw-spec-label">Details</span><span class="tw-spec-value">See product description</span></div>';
  }


  const buttons = Array.from(root.querySelectorAll('[data-tw-info-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-tw-info-panel]'));

  const activate = name => {
    buttons.forEach(button => {
      const active = button.dataset.twInfoTab === name;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });

    panels.forEach(panel => {
      const active = panel.dataset.twInfoPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  buttons.forEach(button => {
    button.addEventListener('click', () => activate(button.dataset.twInfoTab));
  });

  root.dataset.ready = 'yes';
})();



(function(){
  'use strict';

  const root = document.querySelector('.tw-builder [data-tw-info-tabs]');
  if(!root) return;

  const description = root.querySelector('[data-tw-info-description]');
  const toggle = root.querySelector('[data-tw-overview-toggle]');
  const toggleText = root.querySelector('[data-tw-overview-toggle-text]');
  if(!description || !toggle || !toggleText) return;

  let isCollapsible = false;

  const updateToggleVisibility = () => {
    if(description.classList.contains('is-expanded')){
      isCollapsible = true;
      toggle.hidden = false;
      description.classList.add('is-collapsible');
      description.setAttribute('tabindex', '0');
      description.setAttribute('role', 'button');
      description.setAttribute('aria-label', 'Collapse product overview');
      return;
    }

    /* Compare natural content height with the compact clamp. */
    const compactHeight = description.clientHeight;
    const naturalHeight = description.scrollHeight;
    isCollapsible = naturalHeight > compactHeight + 4;

    toggle.hidden = !isCollapsible;
    description.classList.toggle('is-collapsible', isCollapsible);

    if(isCollapsible){
      description.setAttribute('tabindex', '0');
      description.setAttribute('role', 'button');
      description.setAttribute('aria-label', 'Expand product overview');
    }else{
      description.removeAttribute('tabindex');
      description.removeAttribute('role');
      description.removeAttribute('aria-label');
    }
  };

  const setExpanded = (expanded) => {
    description.classList.toggle('is-expanded', expanded);
    toggleText.textContent = expanded ? '↑' : '↓';
    toggleText.setAttribute('aria-label', expanded ? 'Collapse overview' : 'Expand overview');
    toggle.setAttribute('aria-expanded', String(expanded));
    description.setAttribute('aria-label', expanded ? 'Collapse product overview' : 'Expand product overview');

    if(!expanded){
      const panel = description.closest('[data-tw-info-panel]');
      panel?.scrollIntoView({behavior:'smooth', block:'nearest'});
    }
  };

  const toggleOverview = () => {
    if(!isCollapsible && !description.classList.contains('is-expanded')) return;
    setExpanded(!description.classList.contains('is-expanded'));
  };

  toggle.addEventListener('click', (event) => {
    event.stopPropagation();
    toggleOverview();
  });

  /* The overview copy itself is now the click target too. */
  description.addEventListener('click', (event) => {
    if(event.target.closest('a, button, input, select, textarea, label')) return;
    toggleOverview();
  });

  description.addEventListener('keydown', (event) => {
    if(event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    toggleOverview();
  });

  requestAnimationFrame(updateToggleVisibility);
  window.addEventListener('resize', updateToggleVisibility, {passive:true});
})();



(function(){
  'use strict';

  const builder = document.querySelector('.tw-builder');
  if(!builder) return;

  const tabs = Array.from(builder.querySelectorAll('[data-tw-payway-tab]'));
  const panels = Array.from(builder.querySelectorAll('[data-tw-payway-panel]'));

  if(!tabs.length || !panels.length) return;

  const activate = (name) => {
    tabs.forEach(tab => {
      const active = tab.dataset.twPaywayTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });

    panels.forEach(panel => {
      const active = panel.dataset.twPaywayPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => activate(tab.dataset.twPaywayTab));
  });
})();
